import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
// import { MTTbreadcrumbs } from 'src/Globals';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { MTTcomponents } from 'src/Globals';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  // imagename = "breadcrumb-bg.png";
  // image = " url(../assets/images/"+ this.imagename + ")";
  @Input() CurrnetComponentName: string;
  // @Input() Image : any ;
  @Output() BtnClick: EventEmitter<any> = new EventEmitter();
  CurrentComponent: BreadCrumbItem
  //showDeactivate: boolean = false;
  subTitle: string;

  constructor(public translate: TranslateService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.CurrentComponent = MTTcomponents.find(x => x.ComponentName.toLocaleLowerCase().trim() === this.CurrnetComponentName.toLocaleLowerCase().trim());

    // Get Bread Crumb Title
    if (this.CurrentComponent.dynamicTitle) {
      this.CurrentComponent.PageTextKey = this.route.snapshot.data.breadCrumbTitle;
      this.CurrentComponent.ItemTextKey = this.route.snapshot.data.breadCrumbTitle;
    }else {
      this.translate.get(this.CurrentComponent.PageTextKey).subscribe((value)=>{
        this.CurrentComponent.PageTextKey = value;
      })
    }

  }
  Click() {
    this.BtnClick.emit();
  }

}

export class BreadCrumbItem {
  ComponentName: string;
  SubTitle: string;
  PageTextKey: string;
  ItemTextKey: string;
  Route: string;
  ParentComponentName: string;
  Parameters: string;
  HasRoute: boolean;
  Image: string;
  dynamicTitle?: boolean
}
